var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/view/VShadowBuildings
 */
import $ from 'jquery';
import { MDCSlider } from '@material/slider';
import { MDCSwitch } from '@material/switch';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
import { createSlider, createSwitch, formatDate } from './VUtils';
/**
 * @typedef {Object} ShadowBuildingsOptions
 * @property {string} date Date YYYY-MM-DD
 * @property {number} seconds Seconds from midnight
 */
/**
 * @enum {string}
 */
export var EventType = {
    ENABLE: 'enable',
    DISABLE: 'disable',
    CHANGE: 'change',
};
/**
 * @classdesc
 */
var VShadowBuildings = /** @class */ (function (_super) {
    __extends(VShadowBuildings, _super);
    /**
     * @constructor
     */
    function VShadowBuildings() {
        var _this = this;
        var date = new Date();
        var currentVal = (date.getHours() * 2) + (date.getMinutes() < 30 ? 0 : 1);
        var jqElement = $("\n      <div class=\"v-shadow-buildings mdc-elevation--z4\">\n        <div class=\"header\">\n          <div class=\"title\">".concat(i18n('sunLight'), "</div>\n          ").concat(createSwitch('switch'), "\n        </div>\n        <div class=\"inputs\">\n          <div class=\"date-input\">\n            <input type=\"date\" name=\"date\" value=\"").concat(formatDate(new Date()), "\">\n          </div>\n          <div class=\"slider-input\">\n            <i class=\"icon icon-time\"></i>\n            <div class=\"box\">\n              ").concat(createSlider('timeslider', 0, 47, currentVal, false, ' '), "\n            </div>\n          </div>\n        </div>\n      </div>\n    "));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {MDCSlider}
         */
        _this.mdcTimeSlider_ = null;
        /**
         * @private
         * @type {JQuery}
         */
        _this.jqInputDate_ = null;
        _this.initialize_();
        return _this;
    }
    /**
     * Necessary after create and after show/hide
     * @private
     */
    VShadowBuildings.prototype.refreshSlidersLayout_ = function () {
        this.mdcTimeSlider_.layout();
    };
    /**
     * @override
     * @param {boolean} [animation]
     */
    VShadowBuildings.prototype.show = function () {
        this.jqElement_.show();
        this.refreshSlidersLayout_();
    };
    /**
     * @private
     */
    VShadowBuildings.prototype.initialize_ = function () {
        if (!this.jqElement_) {
            return;
        }
        var jqMdcSwitch = this.jqElement_.find('.mdc-switch');
        var jqMdcSlider = this.jqElement_.find('.mdc-slider.timeslider');
        if (!jqMdcSwitch || jqMdcSwitch.length === 0 || !jqMdcSlider || jqMdcSlider.length === 0) {
            return;
        }
        this.switchEnable_ = new MDCSwitch(jqMdcSwitch.get(0));
        this.switchEnable_.listen('click', this.handleSwitchChange_.bind(this));
        this.mdcTimeSlider_ = new MDCSlider(jqMdcSlider.get(0));
        this.mdcTimeSlider_.listen('MDCSlider:change', this.handleChangeTime_.bind(this));
        this.mdcTimeSlider_.listen('MDCSlider:input', this.handleChangeTime_.bind(this));
        this.jqInputDate_ = this.jqElement_.find('input[name="date"]');
        this.jqInputDate_.on('change', this.handleChangeTime_.bind(this));
        this.jqElement_.find('.value').text('hourMins');
        this.handleChangeTime_(false);
    };
    VShadowBuildings.prototype.handleSwitchChange_ = function () {
        var jqInputDiv = this.jqElement_.find('.inputs');
        if (this.switchEnable_.selected) {
            this.emit(EventType.ENABLE);
            jqInputDiv.css('display', 'table');
            this.refreshSlidersLayout_();
        }
        else {
            this.emit(EventType.DISABLE);
            jqInputDiv.hide();
        }
    };
    /**
     * @private
     * @param {boolean} [fireEvent]  Fire event
     */
    VShadowBuildings.prototype.handleChangeTime_ = function (fireEvent) {
        if (fireEvent === void 0) { fireEvent = true; }
        var val = this.mdcTimeSlider_.getValue();
        var hour = Math.floor(val / 2);
        var minutes = val % 2 === 0 ? '00' : '30';
        var hourMins = "".concat(hour, ":").concat(minutes);
        this.jqElement_.find('.value').text(hourMins);
        var date = this.jqInputDate_.val();
        if (fireEvent) {
            this.emit(EventType.CHANGE, { date: date, hourmins: hourMins });
        }
    };
    /**
     * @param {boolean} enable enable
     */
    VShadowBuildings.prototype.toggle = function (enable) {
        this.switchEnable_.selected = enable;
        this.handleSwitchChange_();
    };
    return VShadowBuildings;
}(BaseView));
export default VShadowBuildings;
//# sourceMappingURL=VShadowBuildings.js.map